import api from '../../api';

export default {
    async activeTrial(token) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
                'Authorization': `Bearer ${token}`,
            };
            const response = await api.get(`/order/trial/activate`, {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ativar trial:', error);
                throw error;
        }
    },
    async checkout(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            // Canonical: POST /ecommerce/subscription
            const response = await api.post(`/ecommerce/subscription`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao realizar checkout:', error);
            throw error;
        }
    },
    async validateCoupon(cupon, idCompany) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/ecommerce/cupom/${cupon}/${idCompany}`, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao validar cupom:', error);
            throw error;
        }
    },
    async checkoutCollection(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            // Canonical: POST /ecommerce/payment (one-shot collection/course)
            const response = await api.post(`/ecommerce/payment`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao realizar checkout:', error);
            throw error;
        }
    },
    async getCollectionBySlug(slug){
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/ecommerce/course/url/${slug}`, {
                method: 'GET',
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao obter dados da collection:', error);
                throw error;
        }
    },
    async activeAccount(payload){
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/ecommerce/definir-senha', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ativar conta:', error);
            throw error;
        }
    }
}